import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const base = resolveApiUrl("/api/attractions");

/**
 * @param {{
 *   destination_id?: number | string, // מומלץ: internal_hotel_destinations.id (מ־resolve.internal_destination_id). לא UUID.
 *   lds_code?: string, // סינון לפי LDS — fallback כשאין מזהה פנימי.
 *   date_from?: string,
 *   date_to?: string,
 *   category?: string,
 *   limit?: number,
 *   for_packages?: boolean,
 *   for_hotel_upsell?: boolean,
 * }} params
 */
export async function searchAttractions(params = {}) {
  const ldsTrimmed =
    params.lds_code != null && String(params.lds_code).trim() !== ""
      ? String(params.lds_code).trim()
      : undefined;

  const query = {
    date_from: params.date_from,
    date_to: params.date_to,
    category: params.category,
    limit: params.limit,
    for_packages: params.for_packages === true ? "1" : params.for_packages === false ? "0" : undefined,
    for_hotel_upsell:
      params.for_hotel_upsell === true ? "1" : params.for_hotel_upsell === false ? "0" : undefined,
  };

  if (params.destination_id != null && params.destination_id !== "") {
    query.destination_id = params.destination_id;
  }
  if (ldsTrimmed) {
    query.lds_code = ldsTrimmed;
  }

  const { data } = await axios.get(`${base}/search`, {
    params: query,
    withCredentials: true,
  });
  return data;
}

/**
 * @param {{ attraction_id: number, visit_date?: string, party_size?: number }} body
 */
export async function calculateAttractionPrice(body) {
  const { data } = await axios.post(`${base}/calculate-price`, body, { withCredentials: true });
  return data;
}

/**
 * @param {{
 *   target: 'dynamic_package' | 'order',
 *   target_id: number,
 *   attraction_id: number,
 *   visit_date?: string,
 *   party_size?: number,
 * }} body
 */
export async function addAttractionToOrder(body) {
  const { data } = await axios.post(`${base}/add-to-order`, body, { withCredentials: true });
  return data;
}

export async function fetchPackageAttractionLines(dynamicPackageId) {
  const seg = encodeURIComponent(String(dynamicPackageId).trim());
  const { data } = await axios.get(`${base}/package-lines/${seg}`, { withCredentials: true });
  return data;
}

/**
 * חוקי אטרקציה להצגת הטבות/באדג'ים (ללא שינוי מחיר חבילה).
 * @param {{
 *   dynamic_package_id: number,
 *   destination_id?: number, // מומלץ: internal_hotel_destinations.id (מ־resolve). השרת תומך גם ב-legacy.
 *   package_key?: string,
 *   flight_scope_value?: string,
 *   visit_date?: string,
 *   attraction_id?: number,
 *   limit?: number,
 * }} params
 */
export async function fetchAttractionRulesForPackage(params = {}) {
  const q = {};
  if (params.dynamic_package_id != null && params.dynamic_package_id !== "") {
    q.dynamic_package_id = params.dynamic_package_id;
  }
  if (params.destination_id != null && params.destination_id !== "") {
    q.destination_id = params.destination_id;
  }
  if (params.package_key) q.package_key = params.package_key;
  if (params.flight_scope_value) {
    q.flight_scope_value = params.flight_scope_value;
  }
  if (params.visit_date) q.visit_date = params.visit_date;
  if (params.attraction_id != null && params.attraction_id !== "") {
    q.attraction_id = params.attraction_id;
  }
  q.limit = params.limit ?? 40;
  const { data } = await axios.get(`${base}/rules`, {
    params: q,
    withCredentials: true,
  });
  return data;
}

/**
 * פרטי אטרקציה לעמוד ציבורי — GET /api/attractions/:id (מזהה מספרי או slug לפי תמיכת השרת).
 * @param {string|number} identifier
 */
export async function fetchAttractionByIdentifier(identifier) {
  const seg = encodeURIComponent(String(identifier).trim());
  const { data } = await axios.get(`${base}/${seg}`, {
    withCredentials: true,
  });
  return data;
}
